<template>

    <div>
        <UserList/>
    </div>

</template>

<script>

    import UserList from './common/users/UserList.vue'

    export default {
        name: 'Users',

        components: {
            UserList
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Users.vue